export const DEPLOYMENT_ACTIVE_STATES = [
  'deploying',
  'running',
  'restart_waiting',
  'stopping',
] as const;
export const DEPLOYMENT_INACTIVE_STATES = ['stopped'] as const;
export const DEPLOYMENT_ERROR_STATES = [
  'error',
  'interrupted',
  'unknown',
] as const;
export const DEPLOYMENT_STATES = [
  ...DEPLOYMENT_ACTIVE_STATES,
  ...DEPLOYMENT_INACTIVE_STATES,
  ...DEPLOYMENT_ERROR_STATES,
] as const;

export type DeploymentState = (typeof DEPLOYMENT_STATES)[number];

export type DeploymentProperties = {
  [property: string]: any;
};

export type DeploymentConfiguration = {
  [nodeID: string]: DeploymentProperties;
};

export type Deployment = {
  id: string;
  name: string | null;
  application_id: string;
  pipeline_id: string;
  gateway_id: string;
  state: DeploymentState;
  state_details: string | null;
  configuration: DeploymentConfiguration;
  tags: Array<string>;
  created_at: string;
  updated_at: string;
};
